import { FC } from 'react';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { BlogSectionType } from '../../../models/Content';
import { StyledHeading, StyledSectionText } from './SectionText.styles';
import { transformSectionText } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionText: FC<Props> = ({ contentItem }) => {
    const { title, text, slug } = transformSectionText(contentItem);

    return (
        <StyledSectionText>
            {!!title && (
                <StyledHeading tag="h2" variant="title-300" id={slug}>
                    {title}
                </StyledHeading>
            )}
            <RichTextContent richText={text} />
        </StyledSectionText>
    );
};
